import React from 'react'
import './DashboardNavbar.scss'
import DashboardNavItem from '../DashboardNavItem/DashboardNavItem'
import {CiSearch} from "react-icons/ci"

const DashboardNavbar = () => {
    
    const NavItems = [
        {
            path:"/dashboard",
            name:"Dashboard"
        },
        {
            path:"/dashboard/admissions",
            name:"Admissions",
            submenus:[
                {
                    path:"/dashboard/admissions/applications",
                    name:"Applications"
                },
                {
                    path:"/dashboard/admissions/enquiries",
                    name:"Enquiries"
                }
            ]
        },
        {
            path:"/dashboard/classes",
            name:"Classes"
        },
        // {
        //     path:"/dashboard/settings",
        //     name:"Settings"
        // },
    ]
  return (
    <div id='dashboard-navbar'>
        <div className="dashboard-navigations">
            <ul className='dashboard-menu-list'>
                {
                    NavItems.map((item, index) => (
                        <DashboardNavItem item={item} key={index}/>
                    ))
                }
            </ul>
        </div>
        <div className="dashboard-navbar-search">
            <CiSearch />
            <input type="text" name="" id="" placeholder='Search' />
        </div>
    </div>
  )
}

export default DashboardNavbar